import api from "./api-manager";

const { REACT_APP_API_A39 } = process.env;

export default {
  async ListSearchCampaign(token, adsId, startDate, endDate, orderBy, orderType, start, limit, offSetTime) {
    return api.post(
      `/v1/campaign/search/list`,
      { adsId, startDate, endDate, orderBy, orderType, start, limit, offSetTime },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
  async ListTopKeyword(token, adsId, startDate, endDate, orderBy, orderType) {
    return api.post(
      `/v1/campaign/top-keyword/list`,
      { adsId, startDate, endDate, orderBy, orderType },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
  async ListDisplayCampaign(token, adsId, startDate, endDate, sortOptions, start, limit) {
    console.log("limit display", limit);
    return api.post(
      `/v1/campaign/placement/list`,
      { adsId, startDate, endDate, sortOptions, start, limit },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
  async ListTopAudience(token, adsId, startDate, endDate, sortOptions, start, limit) {
    return api.post(
      `/v1/campaign/top-audiences/list`,
      { adsId, startDate, endDate, sortOptions, start, limit },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
  async ListTopPlacement(token, adsId, startDate, endDate, sortOptions, start, limit) {
    return api.post(
      `/v1/campaign/top-placement/list`,
      { adsId, startDate, endDate, sortOptions, start, limit },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
};
